/*!
  * Multilevel nav slide over functionality
  */
  
(function ($) {
    'use strict';
    
    // Slide over keyboard trap
  var slideOverKeyboardTrap = function(el) {

        // Tabbable elements
        var lastIsMln = el.find('.mln__child__list:first > .mln__has-child:last-child > .mln__child-controls:first > .mln__toggle-btn');
        var tabbable = el.find(
            'a[href],' +
            'area[href],' +
            'input:not([disabled]),' +
            'select:not([disabled]),' +
            'textarea:not([disabled]),' +
            'button:not([disabled]),' +
            'iframe,' +
            'object,' +
            'embed,' +
            '[tabindex="0"],' +
            '[contenteditable]'
        );

        var firstTabbable = tabbable.first();
        var lastTabbable = (lastIsMln.length) ? lastIsMln  : tabbable.last();
        
        // Set focus on first input
        firstTabbable.focus();

        // Redirect last tab to first input
        lastTabbable.on('keydown', function(e) {
            if (e.which === 9 && !e.shiftKey && $('body').hasClass('js-off-canvas-showing')) {
                e.preventDefault();
                firstTabbable.focus();
            }
        });
        
        // Redirect first shift+tab to last input
        firstTabbable.on('keydown', function(e) {
            if (e.which === 9 && e.shiftKey && $('body').hasClass('js-off-canvas-showing')) {
                e.preventDefault();
                lastTabbable.focus();
            }
      });
  };
    
    $.fn.multilevelSlideOver = function (options) {
        $(this).each(function () {
            var $slideOverNav = $(this);
            var settings;
            
            // Setting defaults
            settings = $.extend({
                'slideTitles': true,
                'backButtonMarkup': '<span aria-hidden="true">&lsaquo;</span>'
            }, options);
            
            // Help mln act like overlay nav for mobile devices
            $slideOverNav.find('.mln__has-child').each(function() {
                var $navEl = $(this);
                var currentMenuId = $navEl.find('.mln__child__collapse:first').attr('id');
                var nextCollapseHelper = $navEl.find('.mln__child__collapse__helper:first');
                var menuSectionLabel = $navEl.find(' > .mln__child-controls > a').html();

                $('<div>')
                    .addClass('mln__slide-over-controls')
                    .prependTo(nextCollapseHelper);
                    
                $('<button>')
                    .addClass('mln__back-btn')
                    .attr('type', 'button')
                    .attr('aria-controls', currentMenuId)
                    .html(settings.backButtonMarkup)
                    .prependTo($navEl.find('.mln__slide-over-controls'));
                    
                // Build slide title
                if (settings.slideTitles) {
                    $('<span>')
                        .addClass('mln__slide-over-title')
                        .html(menuSectionLabel)
                        .appendTo($navEl.find('.mln__slide-over-controls'));
                }

                $navEl
                    .find('.mln__back-btn:first')
                    .on('click', function(){
                        $('.mln__toggle-btn[aria-controls="' + currentMenuId + '"]').trigger('click');
                    });
            });


            // Trap keyboard to current panel
            $slideOverNav.find('.mln__toggle-btn, .mln__back-btn').on('click', function(){
                if (mlnViewport().width < 992) {
                    var latestNavShowing = $slideOverNav.find('.mln__has-child--showing:last .mln__child__collapse:first');
                    
                    setTimeout(function(){
                        slideOverKeyboardTrap(latestNavShowing);
                    }, 300);
                }
            });
        });
    };
}(jQuery));
